/**
 * Diagnose course issues
 */

import { getCourseById } from '../services/courseService';

export async function diagnoseCourse(courseId) {
  if (!courseId) {
    courseId = '296faed7-a5f5-4c1f-9e1b-38dd3623c4a0'; // July 30 course
  }
  
  console.log('🔍 COURSE DIAGNOSTICS');
  console.log('=' .repeat(50));
  console.log('Course ID:', courseId);
  
  try {
    const course = await getCourseById(courseId);
    
    console.log('\n📊 BASIC INFO:');
    console.log('Title:', course.title);
    console.log('Status:', course.status);
    
    console.log('\n🎯 CAPACITY ANALYSIS:');
    console.log('Total spots:', course.totalSpots);
    console.log('Available spots:', course.availableSpots);
    
    if (course.availableSpots > course.totalSpots) {
      console.log('❌ PROBLEM: Available spots EXCEEDS total spots!');
      console.log('This will cause transaction failures.');
    }
    
    console.log('\n👥 GENDER SLOTS:');
    console.log('Male slots:', course.maleSlots);
    console.log('Female slots:', course.femaleSlots);
    console.log('Mixed/Other slots:', course.mixedSlots || course.slotsOther);
    console.log('Occupied male:', course.occupiedMaleSlots);
    console.log('Occupied female:', course.occupiedFemaleSlots);
    console.log('Occupied mixed:', course.occupiedMixedSlots);
    
    // Calculate actual availability
    if (course.maleSlots !== undefined || course.femaleSlots !== undefined) {
      const totalGenderSlots = (course.maleSlots || 0) + (course.femaleSlots || 0) + (course.mixedSlots || 0);
      console.log('\n🔢 GENDER-BASED CAPACITY:');
      console.log('Total gender slots:', totalGenderSlots);
      console.log('Should match totalSpots?', totalGenderSlots === course.totalSpots);
      
      if (totalGenderSlots !== course.totalSpots && totalGenderSlots > 0) {
        console.log('⚠️ WARNING: Gender slots don\'t match total spots');
      }
    }
    
    console.log('\n💰 PAYMENT INFO:');
    console.log('Base price:', course.basePrice);
    console.log('Currency:', course.currency);
    console.log('Payment types available:', course.availablePaymentTypes?.length || 0);
    
    if (course.availablePaymentTypes && course.availablePaymentTypes.length > 0) {
      console.log('Payment types:', course.availablePaymentTypes.map(pt => pt.name || pt.type).join(', '));
    }
    
    console.log('\n📋 FORM INFO:');
    console.log('Form ID:', course.formId);
    console.log('Has form?', !!course.form);
    
    console.log('\n🚨 ISSUES FOUND:');
    const issues = [];
    
    if (course.availableSpots > course.totalSpots) {
      issues.push('Available spots exceeds total spots - will cause booking failures');
    }
    
    if (!course.formId) {
      issues.push('No form attached - might prevent publishing');
    }
    
    if (course.availableSpots < 0) {
      issues.push('Negative available spots - course is overbooked');
    }
    
    if (course.maleSlots < 0 || course.femaleSlots < 0) {
      issues.push('Negative gender slots - gender capacity exceeded');
    }
    
    if (issues.length === 0) {
      console.log('✅ No obvious issues found');
    } else {
      issues.forEach(issue => console.log('❌', issue));
    }
    
    console.log('\n📝 RECOMMENDED FIX:');
    if (course.availableSpots > course.totalSpots) {
      console.log('Run this AWS CLI command to fix available spots:');
      console.log(`aws dynamodb update-item --table-name CourseTable --key '{"PK":{"S":"COURSE#${courseId}"},"SK":{"S":"#METADATA#${courseId}"}}' --update-expression "SET availableSpots = :spots" --expression-attribute-values '{":spots":{"N":"${course.totalSpots}"}}' --region ap-southeast-2`);
    }
    
    return course;
    
  } catch (error) {
    console.error('Diagnosis failed:', error);
  }
}

window.diagnoseCourse = diagnoseCourse;